import axiosInstance from ".";



export const getProfile = async () => {
    const response = await axiosInstance.get(`/supplier/profile`)
    return response;
}
export const updateProfile = async (body) => {
    const response = await axiosInstance.patch(`/supplier/profile`, body)
    return response;
}